import { render, staticRenderFns } from "./MasterLayout.vue?vue&type=template&id=031b73ff"
import script from "./MasterLayout.vue?vue&type=script&setup=true&lang=js"
export * from "./MasterLayout.vue?vue&type=script&setup=true&lang=js"
import style0 from "./MasterLayout.vue?vue&type=style&index=0&id=031b73ff&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports